import { getWwwWebFilterStationSuggestions } from '@/api/generated/www-web-filters/www-web-filters';
import type { ListRequest, WebFilterStationSuggestion } from '@/api/generated/schemas';
import {
  defineEntityAsyncSelector,
  listRequestQueryKey,
  selectorPresets,
  toListRequest,
  type NoPickFilters,
} from '@/shared/ui/async-selector';

export interface WebFilterStationRef {
  stationId: number;
  name: string;
  code: string | null;
}

export const stationSelector = defineEntityAsyncSelector<
  WebFilterStationRef,
  WebFilterStationSuggestion,
  ListRequest,
  NoPickFilters
>({
  api: {
    fetch: getWwwWebFilterStationSuggestions,
    buildApiParams: (ctx) => toListRequest(ctx.search, ctx.ids, ctx.extraFilters ?? []),
    queryKey: (request) => listRequestQueryKey('www.web-filters.stations', request),
    mapItem: (s) => ({
      stationId: s.stationId,
      name: s.name,
      code: s.code ?? null,
    }),
  },
  key: (item) => item.stationId,
  objectCategory: 'Station',
  listPicker: 'legacy',
  display: {
    kind: 'nameCode',
    name: (item) => item.name,
    code: (item) => item.code,
  },
  columns: (t) =>
    selectorPresets.nameAndCode({
      name: {
        id: 'name',
        header: t('webFilter.criteria.selectors.columns.name'),
        value: (item) => item.name,
        sortable: true,
      },
      code: {
        id: 'code',
        header: t('webFilter.criteria.selectors.columns.code'),
        value: (item) => item.code,
        emptyDash: '—',
      },
    }),
  i18n: { namespace: 'www' },
});
